import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { formJson } from "../json/FormJson";
import AddUser from "../components/AddUser";
import sanitizeFileName from "../primitives/sanitizeFileName";
import Parse from "parse";
import DropboxChooser from "../components/shared/fields/DropboxChoose";
import Alert from "../primitives/Alert";
import SelectFolder from "../components/shared/fields/SelectFolder";
import SignersInput from "../components/shared/fields/SignersInput";
import Title from "../components/Title";
import PageNotFound from "./PageNotFound";
import RemainderModal from "./RemainderModal";
import { SaveFileSize } from "../constant/saveFileSize";
import { getFileName, isMobile, onChangeInput } from "../constant/Utils";

// `Form` render all type of Form on this basis of their provided in path
function Form() {
  const { id } = useParams();

  if (id === "lM0xRnM3iE") {
    return <AddUser />;
  } else {
    const config = formJson[id];
    if (config) {
      return <Forms {...config} />;
    } else {
      return <PageNotFound prefix={"Form"} />;
    }
  }
}

const Forms = (props) => {
  const maxFileSize = 20;
  const navigate = useNavigate();
  const [signers, setSigners] = useState([]);
  const [folder, setFolder] = useState({ ObjectId: "", Name: "" });
  const [formData, setFormData] = useState({
    Name: "",
    Description: "",
    Note: "",
    TimeToCompleteDays: 15,
    EmailContent: "",
    SendinOrder: "false"
  });
  const [fileupload, setFileUpload] = useState([]);
  const [fileload, setfileload] = useState(false);
  const [percentage, setpercentage] = useState(0);
  const [isReset, setIsReset] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isErr, setIsErr] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const remainderModalRef = useRef(null);
  const handleStrInput = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    handleReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.title]);
  const handleFileInput = (e) => {
    setpercentage(0);
    try {
      let files = e.target.files;
      if (typeof files[0] !== "undefined") {
        const mb = Math.round(files[0].size / Math.pow(1024, 2));
        if (mb > maxFileSize) {
          alert(
            `The selected file size is too large. Please select a file less than ${maxFileSize} MB`
          );
          setFileUpload([]);
          e.target.value = "";
          return;
        } else {
          handleFileUpload(files[0]);
        }
      } else {
        alert("Please select file.");
        return false;
      }
    } catch (error) {
      alert(error.message);
      return false;
    }
  };

  const handleFileUpload = async (file) => {
    setfileload(true);
    const fileName = file.name;
    const size = file.size;
    const name = sanitizeFileName(fileName);
    const pdfFile = file;
    const tenantCode = localStorage.getItem("tenantCode") || "";
    const parseFile = new Parse.File(name, pdfFile, pdfFile.type, {
      tenantCode
    });

    try {
      const response = await parseFile.save({
        progress: (progressValue, loaded, total, { type }) => {
          if (type === "upload" && progressValue !== null) {
            const percentCompleted = Math.round((loaded * 100) / total);
            setpercentage(percentCompleted);
          }
        }
      });

      // The response object will contain information about the uploaded file
      // You can access the URL of the uploaded file using response.url()
      setFileUpload(response.url());
      setfileload(false);
      if (response.url()) {
        const tenantId = localStorage.getItem("TenantId");
        const fileUrl = await SaveFileSize(size, response.url(), tenantId);
        setFileUpload(fileUrl);
        return fileUrl;
      }
    } catch (error) {
      setfileload(false);
      setpercentage(0);
      console.error("Error uploading file:", error);
    }
  };

  const dropboxSuccess = async (files) => {
    setfileload(true);
    const file = files[0];
    const size = file.bytes;
    const url = file.link;
    const mb = Math.round(file.bytes / Math.pow(1024, 2));

    if (mb > maxFileSize) {
      setTimeout(() => {
        alert(
          `The selected file size is too large. Please select a file less than ${maxFileSize} MB`
        );
      }, 500);
      return;
    } else {
      const name = sanitizeFileName(file.name);

      const parseFile = new Parse.File(name, { uri: url });

      try {
        const response = await parseFile.save({
          progress: (progressValue, loaded, total, { type }) => {
            if (type === "upload" && progressValue !== null) {
              const percentCompleted = Math.round((loaded * 100) / total);
              setpercentage(percentCompleted);
            }
          }
        });
        setFileUpload(response.url());
        setfileload(false);

        if (response.url()) {
          const tenantId = localStorage.getItem("TenantId");
          SaveFileSize(size, response.url(), tenantId);
          return response.url();
        }
      } catch (error) {
        setfileload(false);
        setpercentage(0);
        console.error("Error uploading file:", error);
      }
    }
  };
  const dropboxCancel = async () => {};
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsSubmit(true);
    const remainderData = remainderModalRef.current?.handleSave() ?? null;
    try {
      const currentUser = Parse.User.current();
      const object = new Parse.Object(props.Cls);
      object.set("Name", formData?.Name);
      object.set("Description", formData?.Description);
      object.set("Note", formData?.Note);
      object.set("EmailContent", formData?.EmailContent);
      object.set("reminderSettings", remainderData);
      object.set("AutomaticReminders", remainderData?.enabled);
      if (
        props.title === "Request Signatures" ||
        props.title === "New Template"
      ) {
        object.set(
          "TimeToCompleteDays",
          parseInt(formData?.TimeToCompleteDays)
        );
      }
      if (props.title !== "Sign Yourself") {
        const isChecked = formData.SendinOrder === "false" ? false : true;
        object.set("SendinOrder", isChecked);
      }
      object.set("URL", fileupload);
      object.set("CreatedBy", Parse.User.createWithoutData(currentUser.id));
      if (folder && folder.ObjectId) {
        object.set("Folder", {
          __type: "Pointer",
          className: props.Cls,
          objectId: folder.ObjectId
        });
      }
      if (signers && signers.length > 0) {
        object.set("Signers", signers);
      }
      const ExtCls = JSON.parse(localStorage.getItem("Extand_Class"));
      object.set("ExtUserPtr", {
        __type: "Pointer",
        className: "contracts_Users",
        objectId: ExtCls[0].objectId
      });

      const res = await object.save();
      if (res) {
        setSigners([]);
        setFolder({ ObjectId: "", Name: "" });
        setFormData({
          Name: "",
          Description: "",
          Note: ""
        });
        setFileUpload([]);
        setpercentage(0);
        navigate(`/${props?.redirectRoute}/${res.id}`);
      }
    } catch (err) {
      console.log("err ", err);
      setIsErr(true);
    } finally {
      setIsAlert(true);
      setTimeout(() => {
        setIsAlert(false);
      }, 1000);
      setIsSubmit(false);
    }
  };

  const handleFolder = (data) => {
    setFolder(data);
  };
  const handleSigners = (data) => {
    if (data && data.length > 0) {
      const updateSigners = data.map((x) => ({
        __type: "Pointer",
        className: "contracts_Contactbook",
        objectId: x
      }));
      setSigners(updateSigners);
    }
  };

  const handleReset = () => {
    setIsReset(true);
    setSigners([]);
    setFolder({ ObjectId: "", Name: "" });
    setFormData({
      Name: "",
      Description: "",
      Note:
        props.title === "Sign Yourself"
          ? "Note to myself"
          : "Please review and sign this document",
      TimeToCompleteDays: 15,
      EmailContent:
        "<html><head><meta http-equiv='Content-Type' content='text/html; charset=UTF-8' /></head><body>" +
        "<div style='background-color: #f5f5f5; padding: 20px'>" +
        "<div style='box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px; background: white; padding-bottom: 20px;'>" +
        "<div style='padding:10px 10px 0 10px'>" +
        "<img src='http://dogmasystems.in/wp-content/uploads/2026/05/Logo-Dogma-Digital-scaled.png' style='padding:5px;height:130px;' />" +
        "</div>" +
        "<div style='padding:2px; font-family: system-ui; background-color: {{themeBGcolor}};'>" +
        "<p style='font-size: 20px; font-weight: 400; color: white; padding-left: 20px;'>Digital Signature Request</p>" +
        "</div>" +
        "<div>" +
        "<p style='padding: 20px; font-family: system-ui; font-size: 14px; margin-bottom: 10px;'>" +
        "Ciao {{receiver_name}},<br>" +
        "Come stai? {{sender_name}} ha richiesto di visionare e firmare il <strong>document</strong>.<br>" +
        "Si richiede la tua accettazione e firma per procedere con i prossimi passi.<br>" +
        "<a href='{{signing_url}}'>" +
        "<button style='padding: 12px; background-color: #d46b0f; color: white; border: 0px; " +
        "box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px; " +
        "font-weight: bold; margin-top: 30px;'>Sign URL</button>" +
        "</a><br>" +
        "Se hai qualche domanda o hai bisogno di ulteriori informazioni, contatta direttamente il tuo referente senza rispondere a questa email.<br><br>" +
        "Grazie,<br>" +
        "Il team di DogmaSign™" +
        "</p>" +
        "<div style='padding: 5px 0px 5px 25px; display: flex; flex-direction: row; justify-content: space-around;'>" +
        "<table>" +
        "<tr>" +
        "<td style='font-weight: bold; font-family: sans-serif; font-size: 15px;'>Sender</td>" +
        "<td></td>" +
        "<td style='color: #626363; font-weight: bold;'>{{sender_name}}</td>" +
        "</tr>" +
        "<tr>" +
        "<td style='font-weight: bold; font-family: sans-serif; font-size: 15px;'>Organization</td>" +
        "<td></td>" +
        "<td style='color: #626363; font-weight: bold;'>{{company_name}}</td>" +
        "</tr>" +
        "<tr>" +
        "<td style='font-weight: bold; font-family: sans-serif; font-size: 15px;'>Expires on</td>" +
        "<td></td>" +
        "<td style='color: #626363; font-weight: bold;'>{{expiry_date}}</td>" +
        "</tr>" +
        "</table>" +
        "</div>" +
        "<div style='margin-left: 70px;'></div>" +
        "<div style='display: flex; justify-content: center; margin-top: 10px;'></div>" +
        "</div>" +
        "</div>" +
        "<div>" +
        "<p>This is an automated email from DogmaSign™. For any queries regarding this email, please contact the sender <strong>{{sender_mail}}</strong> directly.</p>" +
        "</div>" +
        "</div>" +
        "</body></html>",
      SendinOrder: "true"
    });
    setFileUpload([]);
    setpercentage(0);
    setTimeout(() => setIsReset(false), 50);
  };

  return (
    <div className="shadow-md rounded my-2 p-3 bg-[#ffffff] md:border-[1px] md:border-gray-600/50">
      <Title title={props?.title} />
      {isAlert && (
        <Alert type={isErr ? "danger" : "success"}>
          {isErr
            ? "Something went wrong please try again!"
            : `${props.msgVar} created successfully!`}
        </Alert>
      )}
      {isSubmit ? (
        <div style={{ height: "300px" }}>
          <div
            style={{
              marginLeft: "45%",
              marginTop: "150px",
              fontSize: "45px",
              color: "#3dd3e0"
            }}
            className="loader-37"
          ></div>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <h1 className="text-[20px] font-semibold mb-4">{props?.title}</h1>
          {fileload && (
            <div className="flex items-center gap-x-2">
              <div className="h-2 rounded-full w-[200px] md:w-[400px] bg-gray-200">
                <div
                  className="h-2 rounded-full bg-blue-500"
                  style={{ width: `${percentage}%` }}
                ></div>
              </div>
              <span className="text-black text-sm">{percentage}%</span>
            </div>
          )}
          <div className="text-xs">
            <label className="text-lg font-[400] text-gray-800">
              File<span className="text-red-500 text-[13px]">*</span>
            </label>
            {fileupload?.length > 0 ? (
              <div className="flex gap-2 justify-center items-center">
                <div className="flex justify-between items-center px-2 py-2 w-full font-bold rounded border-[1px] border-[#ccc] text-gray-500 bg-white text-[13px]">
                  <div className="break-all">
                    file selected : {getFileName(fileload)}
                  </div>
                  <div
                    onClick={() => setFileUpload([])}
                    className="cursor-pointer px-[10px] text-[20px] font-bold bg-white text-red-500"
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </div>
                </div>
                {process.env.REACT_APP_DROPBOX_API_KEY && (
                  <DropboxChooser
                    onSuccess={dropboxSuccess}
                    onCancel={dropboxCancel}
                  />
                )}
              </div>
            ) : (
              <div className="flex gap-2 justify-center items-center">
                <input
                  type="file"
                  className="bg-white px-2 py-1.5 w-full border-[1px] border-gray-300 rounded focus:outline-none text-xs"
                  onChange={(e) => handleFileInput(e)}
                  accept="application/pdf"
                  required
                />
                {process.env.REACT_APP_DROPBOX_API_KEY && (
                  <DropboxChooser
                    onSuccess={dropboxSuccess}
                    onCancel={dropboxCancel}
                  />
                )}
              </div>
            )}
          </div>
          <div className="text-xs mt-2">
            <label className="text-lg font-[400] text-gray-800">
              {props.title === "New Template"
                ? "Template Title"
                : "Document Title"}
              <span className="text-red-500 text-[13px]">*</span>
            </label>
            <input
              name="Name"
              className="px-3 py-2 w-full border-[1px] border-gray-300 rounded focus:outline-none text-xs"
              value={formData.Name}
              onChange={(e) => handleStrInput(e)}
              required
            />
          </div>
          <div className="text-xs mt-2">
            <label className="text-lg font-[400] text-gray-800">
              Description
            </label>
            <input
              name="Description"
              className="px-3 py-2 w-full border-[1px] border-gray-300 rounded focus:outline-none text-xs"
              value={formData.Description}
              onChange={(e) => handleStrInput(e)}
            />
          </div>
          {props.signers && (
            <SignersInput onChange={handleSigners} isReset={isReset} required />
          )}
          <div className="text-xs mt-2">
            <label className="text-lg font-[400] text-gray-800">
              Note<span className="text-red-500 text-[13px]">*</span>
            </label>
            <input
              name="Note"
              className="px-3 py-2 w-full border-[1px] border-gray-300 rounded focus:outline-none text-xs"
              value={formData.Note}
              onChange={(e) => handleStrInput(e)}
              required
            />
          </div>
          <div className="text-xs mt-2">
            <div className="d-flex">
              <label className="text-lg font-[400] text-gray-800 flex-1">
                HTML
              </label>
              <button
                type="button"
                onClick={() => setShowPreview(true)}
                className="px-3 py-2 bg-blue-500 text-white rounded text-xs hover:bg-blue-600 focus:outline-none flex-2"
                disabled={!formData.EmailContent}
              >
                Preview
              </button>
            </div>
            {/*<textarea*/}
            {/*    name="Note"*/}
            {/*    className="px-3 py-2 w-full border-[1px] border-gray-300 rounded focus:outline-none text-xs"*/}
            {/*    value={formData.Note}*/}
            {/*    onChange={(e) => handleStrInput(e)}*/}
            {/*    required*/}
            {/*/>*/}
            <textarea
              placeholder="Enter HTML"
              rows={4}
              value={formData.EmailContent}
              name="EmailContent"
              onChange={(e) => handleStrInput(e)}
              className="px-3 py-2 w-full border-[1px] border-gray-300 rounded focus:outline-none text-xs"
              style={{ whiteSpace: "pre-wrap" }}
              cols="50"
            />
          </div>
          <SelectFolder
            onSuccess={handleFolder}
            folderCls={props.Cls}
            isReset={isReset}
          />

          {(props.title === "Request Signatures" ||
            props.title === "New Template") && (
            <div className="text-xs mt-2">
              <label className="text-lg font-semibold text-gray-800">
                Time To Complete (Days)
                <span className="text-red-500 text-[13px]">*</span>
              </label>
              <input
                type="number"
                name="TimeToCompleteDays"
                className="px-3 py-2 w-full border-[1px] border-gray-300 rounded focus:outline-none text-xs"
                value={formData.TimeToCompleteDays}
                onChange={(e) => handleStrInput(e)}
                required
              />
            </div>
          )}
          {props.title !== "Sign Yourself" && (
            <div className="text-xs mt-2">
              <label className="text-lg font-semibold text-gray-800">
                Send In Order
              </label>
              <div className="flex items-center gap-2 ml-2 mb-1">
                <input
                  type="radio"
                  value={"true"}
                  name="SendinOrder"
                  checked={formData.SendinOrder === "true"}
                  className=""
                  onChange={handleStrInput}
                />
                <div className="text-center">Yes</div>
              </div>
              <div className="flex items-center gap-2 ml-2 mb-1">
                <input
                  type="radio"
                  value={"false"}
                  name="SendinOrder"
                  checked={formData.SendinOrder === "false"}
                  onChange={handleStrInput}
                />
                <div className="text-center">No</div>
              </div>
            </div>
          )}
          {(props.title === "Request Signatures" ||
            props.title === "New Template") && (
            <RemainderModal ref={remainderModalRef} />
          )}
          <div className="flex items-center mt-3 gap-2 text-white">
            <button
              className={`${
                isSubmit && "cursor-progress"
              } bg-[#3F464B] rounded-sm shadow-md text-[13px] font-semibold uppercase text-white py-1.5 px-2.5 focus:outline-none`}
              type="submit"
              disabled={isSubmit}
            >
              Next
            </button>
            <div
              className="cursor-pointer  rounded-sm shadow-md border-2 border-gray-600 text-[13px] font-semibold uppercase primary-color py-1.5 px-2.5 text-center ml-[2px] focus:outline-none hover-primary-color"
              onClick={() => handleReset()}
            >
              Reset
            </div>
          </div>
        </form>
      )}
      {showPreview && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
          onClick={() => setShowPreview(false)}
        >
          <div
            className="bg-white rounded p-4 max-w-3xl max-h-[80vh] min-w-[600px] min-h-[300px] overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative mb-4">
              <button
                onClick={() => setShowPreview(false)}
                className="absolute right-0 top-1 text-red-500 font-bold text-2xl leading-none"
                aria-label="Close preview"
              >
                &times;
              </button>
              <h2 className="text-xl font-bold text-center">Preview</h2>
            </div>
            <div
              className="border p-4"
              dangerouslySetInnerHTML={{
                __html: formData.EmailContent || "<p>No content available</p>"
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
export default Form;
